import { ajaxRequest } from "../../Utils/Ajax/ajax";
import { loadMultipageForm } from "../../Utils/MultiPageForm/loadMultipageForm";


export function loadCourseSetup(){
    
    loadMultipageForm(send)
 
}

function send(data, btn){
    const instanceId = $("#instance-id").val()
   
    const url = '/course/setup/' +  instanceId.toString()

    const success = function (data){

        $("#links").html(data.html)

        if (data.activationCode){
            // show qr code -> download
            const qrcode = new QRCode("qrcode",{
                text: data.activationCode,
                width: 128,
                height: 128,
            });

            $("#code-url").html(data.activationCode)

            $("#qrcode-btn").show()
            $(document).on("click",".download-qr", function(){
                const src = $("#qrcode").find("img").attr('src');
                const a = document.createElement("a");
                a.href = src;
                const code = $("#code-url").html().split("ab/")[1];
                a.download = "QrCode-" + code + ".png";
                a.click();
            });
        }
    }

    return ajaxRequest(url, success, data, btn)
}